export type AalLevel = "aal1" | "aal2";

export type ProtectedOperation =
  | "disciplinary_penalty_create"
  | "disciplinary_penalty_record_defense"
  | "disciplinary_penalty_lift"
  | "membership_category_change"
  | "institutional_role_grant"
  | "institutional_role_revoke"
  | "administrative_role_grant"
  | "administrative_role_revoke"
  | "staff_create"
  | "credential_reset";

export interface AalState {
  currentLevel: AalLevel;
  nextLevel: AalLevel;
  status: "loading" | "ready" | "unavailable";
  elevatedAt: number | null;
}

export type ChallengeNeeded =
  | { needed: false }
  | { needed: true; reason: "never-elevated" | "elevation-window-expired" }
  | { needed: false; blocked: "no-verified-factor" | "aal-unavailable" };

export const ELEVATION_WINDOW_MS = 10 * 60 * 1000;

function elevationExpired(elevatedAt: number | null, now: number): boolean {
  return elevatedAt !== null && now - elevatedAt >= ELEVATION_WINDOW_MS;
}

function challengeForAal1(aal: AalState, elevatedAt: number | null): ChallengeNeeded {
  if (aal.nextLevel !== "aal2") return { needed: false, blocked: "no-verified-factor" };
  return { needed: true, reason: elevatedAt === null ? "never-elevated" : "elevation-window-expired" };
}

export function challengeNeededFor(
  _operation: ProtectedOperation,
  aal: AalState,
  elevatedAt: number | null,
  now: number,
): ChallengeNeeded {
  if (aal.status === "unavailable") return { needed: false, blocked: "aal-unavailable" };
  if (aal.currentLevel !== "aal2") return challengeForAal1(aal, elevatedAt);
  return elevationExpired(elevatedAt, now) ? { needed: true, reason: "elevation-window-expired" } : { needed: false };
}

export function normalizeAalLevel(value: unknown): AalLevel {
  return value === "aal2" ? "aal2" : "aal1";
}
